var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    color: '#fff',
    background: '#000',
  })},[_c('header',{staticClass:"d-print-none"},[_c('div',{staticClass:"desktop-logo-wrapper"},[_c(_setup.BaseLogo,{staticClass:"ml-4"}),_c('img',{style:({maxWidth: '56px'}),attrs:{"src":require('~img/logos/logo-lieferando-white.png'),"alt":"Lieferando Logo white"}})],1),_c(_setup.Navbar,{attrs:{"show-chevrons":false,"show-redeem-button":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }